<app-custom-progress-spinner></app-custom-progress-spinner>
<router-outlet></router-outlet>
<p-confirmDialog></p-confirmDialog>
